/**
 * 描述：检查输入框输入的名称是否重复
 * 日期：2017-7-13
 * 作者：Bai.Zhiming
 */
"use strict";
angular.module("checkNameRepeatedModule", [])
    .directive("checkNameRepeated", ["$timeout", "trsHttpService", function($timeout, trsHttpService) {
        return {
            restrict: "A",
            replace: false,
            link: function(scope, elem, attrs) {
                init();
                var flagArray = elem.attr("is-repeat").split(".");
                var isemail = elem.attr("isemail");
                var objectid;
                if (elem.attr("objectid")) {
                    var objectidArray = elem.attr("objectid").split(".");
                    objectid = scope[objectidArray[0]][objectidArray[1]];
                }

                function init() {
                    var attr = elem.attr("ng-model");
                    scope.$watch(attr, function(newV, oldV) {
                        if (newV) {
                            checkName(newV);
                        }
                    });
                }
                var promise;
                /**
                 * [checkName description]校验名称重复
                 */
                function checkName(checkName) {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        var params = {
                            serviceid: "mlf_tenant",
                            methodname: "checkTenantName",
                            TENANTNAME: checkName,
                            TENANTID: objectid
                        };
                        if (isemail) {
                            delete params.TENANTNAME;
                            params.methodname = "checkLoginEmail";
                            params.EMAIL = checkName;
                        }
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                            var span = elem.prev("span");
                            var son = span.children()[0];
                            if ($(son).html() == '当前租户名称已存在') {
                                span.html("");
                            }
                            elem.removeClass("ng-invalid-repeat");
                            scope[flagArray[0]][flagArray[1]] = false;
                        }, function(data) {
                            var span = elem.prev("span");
                            span.html('<p class="validation-invalid">' + data.DETAIL + '</p><i></i>');
                            elem.addClass("ng-invalid-repeat");
                            scope[flagArray[0]][flagArray[1]] = true;
                        });
                    }, 200);
                    return promise;
                }
            }
        };
    }]);